export const API_URL_ORDER = "/order";
